/** @format */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	getMissedContributions,
	checkAutoDraftEligibility,
	MissedContribution,
} from "../actions/autoDraftAction";

interface AutoDraftState {
	missedContributions: MissedContribution[];
	totalMissedCount: number;
	isLoading: boolean;
	error: string | null;
	eligibility: any | null;
	eligibilityLoading: boolean;
	eligibilityError: string | null;
}

const initialState: AutoDraftState = {
	missedContributions: [],
	totalMissedCount: 0,
	isLoading: false,
	error: null,
	eligibility: null,
	eligibilityLoading: false,
	eligibilityError: null,
};

const autoDraftSlice = createSlice({
	name: "autoDraft",
	initialState,
	reducers: {
		clearAutoDraftError: (state) => {
			state.error = null;
			state.eligibilityError = null;
		},
	},
	extraReducers: (builder) => {
		// Get Missed Contributions
		builder
			.addCase(getMissedContributions.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(getMissedContributions.fulfilled, (state, action) => {
				state.isLoading = false;
				state.missedContributions = action.payload.data || [];
				state.totalMissedCount =
					action.payload.data?.reduce(
						(sum: number, mc: MissedContribution) => sum + mc.missedCount,
						0
					) || 0;
			})
			.addCase(getMissedContributions.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload as string;
				state.missedContributions = [];
				state.totalMissedCount = 0;
			});

		// Check Auto-Draft Eligibility
		builder
			.addCase(checkAutoDraftEligibility.pending, (state) => {
				state.eligibilityLoading = true;
				state.eligibilityError = null;
			})
			.addCase(checkAutoDraftEligibility.fulfilled, (state, action) => {
				state.eligibilityLoading = false;
				state.eligibility = action.payload.data;
			})
			.addCase(checkAutoDraftEligibility.rejected, (state, action) => {
				state.eligibilityLoading = false;
				state.eligibilityError = action.payload as string;
				state.eligibility = null;
			});
	},
});

export const { clearAutoDraftError } = autoDraftSlice.actions;
export default autoDraftSlice.reducer;
